import { ReactElement, ReactNode } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import SelectCompany from './pages/SelectCompany';
import Layout from './components/utils/Layout';
import MyConsents from './pages/MyConsents';
import ConsentList from './pages/ConsentList';
import MyData from './pages/MyData';
import MyRequests from './pages/MyRequests';
import MyComplaints from './pages/MyComplaints';
import RightsFAQs from './pages/RightsFAQs';

function RequireAuth({ children }: { children: ReactNode }): ReactElement {
  const token = localStorage.getItem('token');
  if (!token || token === 'undefined') return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" hideProgressBar autoClose={3000} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/select-company"
          element={
            <RequireAuth>
              <SelectCompany />
            </RequireAuth>
          }
        />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/my-consents" replace />} />
                  <Route path="/my-consents" element={<MyConsents />} />
                  <Route path="/consents/:companyId" element={<ConsentList />} />
                  <Route path="/consents/:companyId/my-data" element={<MyData />} />
                  <Route path="/consents/:companyId/requests" element={<MyRequests />} />
                  <Route path="/complaints" element={<MyComplaints />} />
                  <Route path="/rights" element={<RightsFAQs />} />
                  <Route path="*" element={<Navigate to="/my-consents" replace />} />
                </Routes>
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
